import Utils from "Engine/Utils";
import GlobalDispatcher from "Engine/events/GlobalDispatcher";
import EntryPoint from "Engine/EntryPoint";

export default new class RelaxModel {
    constructor() {

        this.availibleLanduages = [
            'cs',
            'da',
            'de',
            'el',
            'en',
            'es',
            'et',
            'fi',
            'fr',
            'hr',
            'hu',
            'it',
            'lt',
            'lv',
            'nl',
            'no',
            'pl',
            'pt',
            'ro',
            'ru',
            'sk',
            'sv',
            'tr',
            'vi'
        ];
        this.usedLang = 'en';

        this.availableAutoPlayStates = [1];
        this.maxAutoplayCount = 1000;
        this.availableAutoPlayCounts = [10, 50, 100, 250, 500];
        this.availableFastSpin = true;
        this.availableFastStop = true;
        this.availableAutoPlay = true;//false;
        this.availableAutoPlayMobile = false;

        this.immediatePayouts = false;

        this.gameId = 'icaruswilds';
        this.sid = '';
        this.currency = 'EUR';
        this.clientid = '';
        this.mode = 'dev';
        this.channel = 'web';
        this.partnerid = 1;
        this.remoteusername = '';
        this.replaytoken = '';
        this.servertime = 0;
        this.token = '';
        this.userid = '';
        this.country = null;
        this.lastLogin = null;
        this.savedSettings = null;
        this.ended = true;
        this.restoreVersion = 0;
        this.restoreState = null;

        this.moneyMode = '';//'fun';
        this.ticket = '';
        this.lang = 'en_GB';
        this.homeurl = '';
        this.jurisdiction = ''; //'SE';
        this.fullscreen = false;
        this.rgSeUri = 2;
        this.rgStUri = 1;
        this.rgSlUri = 3;
        this.rcElapsed = 1000;
        this.rcInterval = 3600;
        this.rcHistoryUrl = '';
        this.rcShowResult = false;

        this.addListeners();
        this.parseUrlData();
        this.setJurisdictionParams();
    }

    addListeners() {
        GlobalDispatcher.add('preloaderController:loadingPreloaderComplete', this.loadingPreloaderComplete, this);
    }

    loadingPreloaderComplete() {
        this.partnerid = EntryPoint.configRelaxData.partnerid;
        this.mode = EntryPoint.configRelaxData.mode;
        this.channel = EntryPoint.configRelaxData.channel;
        this.gameId = EntryPoint.configRelaxData.gameref;

        this.rcInterval = EntryPoint.configRelaxData.rcinterval;
        this.rcElapsed = EntryPoint.configRelaxData.rcelapsed;

        this.immediatePayouts = EntryPoint.configRelaxData.immediatePayouts;

        this.gameServerAPIendpointURL = EntryPoint.configRelaxData.gameServerAPIendpointURL;
        this.tokenAPIEndpointURL = EntryPoint.configRelaxData.tokenAPIEndpointURL;
        this.gameReplayServiceURL = EntryPoint.configRelaxData.gameReplayServiceURL;

        this.parseUrlData();
        this.setJurisdictionParamsFromConfig();
    }

    parseUrlData() {
        this.ticket = Utils.getUrlParam('ticket', this.ticket);
        this.moneyMode = Utils.getUrlParam('moneymode', this.moneyMode);
        this.lang = Utils.getUrlParam('lang', this.lang);
        this.homeurl = Utils.getUrlParam('homeurl', this.homeurl);
        this.jurisdiction = Utils.getUrlParam('jurisdiction', this.jurisdiction);
        this.fullscreen = Utils.getUrlParam('fullscreen', this.fullscreen);
        this.rgSeUri = Utils.getUrlParam('rg_se_uri', this.rgSeUri);
        this.rgStUri = Utils.getUrlParam('rg_st_uri', this.rgStUri);
        this.rgSlUri = Utils.getUrlParam('rg_sl_uri', this.rgSlUri);
        this.rcElapsed = Utils.getUrlParam('rcelapsed', this.rcElapsed);
        this.rcInterval = Utils.getUrlParam('rcinterval', this.rcInterval);
        this.rcHistoryUrl = Utils.getUrlParam('rchistoryurl', this.rcHistoryUrl);
        this.channel = Utils.getUrlParam('channel', this.channel);
        this.partnerid = +Utils.getUrlParam('partnerid', this.partnerid);
        this.rcShowResult = Utils.getUrlParam('rcshowresult', this.rcShowResult);
        this.rciframeurl = Utils.getUrlParam('rciframeurl', this.rciframeurl);

        let lData = this.lang.split('_');
        //this.lang = lData[0];
        //this.jurisdiction = lData[1];

        if (this.availibleLanduages.indexOf(lData[0]) === -1) {
            this.usedLang = 'en';
        } else {
            this.usedLang = lData[0];
        }

        if (this.moneyMode === '') {
            if (this.ticket !== '') {
                this.moneyMode = 'real';
            } else {
                this.moneyMode = 'fun';
            }
        }

        //console.log(this);
    }

    setJurisdictionParams() {
        this.availableAutoPlayStates = [1];
        this.availableFastSpin = true;
        this.availableFastStop = true;
        this.availableAutoPlay = true;
        this.availableAutoPlayMobile = true;

        if (this.jurisdiction.toUpperCase() === 'DK' || this.jurisdiction.toUpperCase() === 'SE') {
            this.availableFastSpin = false;
            this.availableFastStop = false;
        }

        if (this.jurisdiction.toUpperCase() === 'GB' || this.jurisdiction.toUpperCase() === 'UK') {
            this.maxAutoplayCount = 100;
            this.availableAutoPlay = false;
            this.availableAutoPlayMobile = false;
        }
    }

    setJurisdictionParamsFromConfig() {
        let markedData = null;
        if(EntryPoint.configRelaxData.market.hasOwnProperty(this.jurisdiction.toLowerCase())) {
            markedData = EntryPoint.configRelaxData.market[this.jurisdiction.toLowerCase()];
        } else {
            markedData = EntryPoint.configRelaxData.market['default'];
        }
        if (markedData) {
            this.availableFastSpin = markedData.hasOwnProperty('QuickSpin') ? markedData.QuickSpin : this.availableFastSpin;
            this.availableFastStop = markedData.hasOwnProperty('Quickstop') ? markedData.Quickstop : this.availableFastStop;
            this.availableAutoPlay = markedData.hasOwnProperty('Autoplay') ? markedData.Autoplay : this.availableAutoPlay;
            this.availableAutoPlayMobile = markedData.hasOwnProperty('MobileAutoPlayIsAvailable') ? markedData.MobileAutoPlayIsAvailable : this.availableAutoPlayMobile;
            this.availableAutoPlayCounts = markedData.hasOwnProperty('AutoplayRounds') ? markedData.AutoplayRounds : this.availableAutoPlayCounts;
            this.spinTime = markedData.hasOwnProperty('spinTime') ? markedData.spinTime : EntryPoint.configRelaxData.market['default'].spinTime;
        }

        //this.availableAutoPlay = false;
        //this.availableAutoPlayMobile = false;
    }

    exitGame() {
        if (this.homeurl !== '') {
            window.location.href = this.homeurl;
        } else {
            window.history.back()
        }

        EntryPoint.PostMessages && EntryPoint.PostMessages.onExitGame();
    }

    accountHistory() {
        if (this.rcHistoryUrl !== '') {
            EntryPoint.PostMessages && EntryPoint.PostMessages.onShowHistory();
            window.location.href = this.rcHistoryUrl;
        }
    }
}
